import './Primary.scss';
import { capitalize } from '@sonar-software/sonar-ts-lib';
import { FilterComponent } from './FilterComponent';
import { Flex } from 'antd';
import { getFilterId } from '../@arch/lib';
import { ApiCodeToggle } from '@periscopes/general/filters';
import { COPY_SPECIFIC, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { SearchInput } from '@ui/general';
export const PrimaryFilter = (props) => {
    var _a, _b;
    const { format, id, label, metadata, onChange, params, placeholder, value } = props;
    const searchRef = useRef(null);
    const internalValue = (_b = (_a = params[metadata !== null && metadata !== void 0 ? metadata : '']) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '';
    const hasInternal = Boolean(internalValue);
    const [toggledInternal, setToggledInternal] = useState(hasInternal && !props.displayAsTag);
    const displayInternal = hasInternal || toggledInternal;
    const displayValue = displayInternal ? internalValue : value;
    useEffect(() => {
        if (searchRef.current) {
            searchRef.current.setText(displayValue !== null && displayValue !== void 0 ? displayValue : '');
        }
    }, [displayValue]);
    const baseLabel = capitalize(label !== null && label !== void 0 ? label : '');
    const adjustedLabel = displayInternal ? baseLabel.replace(COPY_SPECIFIC.NAME, COPY_SPECIFIC.API_NAME) : baseLabel;
    const handleToggle = useCallback((change) => {
        var _a;
        onChange({
            Name: {
                format,
                value: change.useInternal ? displayValue : ''
            },
            [id]: {
                format,
                value: change.useInternal ? '' : displayValue
            }
        });
        setToggledInternal((_a = change.useInternal) !== null && _a !== void 0 ? _a : false);
    }, [displayValue, format, id, onChange]);
    return (React.createElement(FilterComponent, Object.assign({ className: 'primary-filter' }, props, { label: adjustedLabel, tagProps: {
            id: displayInternal ? metadata !== null && metadata !== void 0 ? metadata : id : id
        }, value: displayValue }),
        React.createElement(Flex, { align: 'center', gap: 8 },
            React.createElement(SearchInput, { className: 'filter', defaultValue: displayValue, id: getFilterId(id), onChange: (query = '') => onChange({
                    [displayInternal ? metadata !== null && metadata !== void 0 ? metadata : id : id]: {
                        format,
                        value: query
                    }
                }), placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : PLACEHOLDERS_COPY.FILTER_BY(adjustedLabel), ref: searchRef }),
            React.createElement(ApiCodeToggle, { checked: toggledInternal, onChange: handleToggle }))));
};
